module.exports = __webpack_public_path__ + "static/media/strictly-equal-ages.3d2ee12d.png";